export default __webpack_public_path__ + "static/media/image.ceytech-systems-solutions-pvt-ltd-.c44d3c70.png";